module.exports = __webpack_public_path__ + "static/media/btn_google_signin_light_normal_web2x.1ce1aaa5.png";